export const isPreprodHost = (): boolean => window.location.hostname.includes('preprod');

// Offsets consumed by the fixed header stack (--app-banner-height readers in App.js, Home, UpdateNotification)
export const PREPROD_BANNER_SPACE = '[--app-banner-height:24px]';
// Download banner (48px) + this bar (24px); below 500px height the download banner hides, the bar stays
export const APP_AND_PREPROD_BANNER_SPACE =
  '[--app-banner-height:72px] [@media(max-height:499px)]:[--app-banner-height:24px]';

const PreprodBanner = () => {
  if (!isPreprodHost()) return null;
  return (
    <div className="flex h-6 items-center justify-center bg-amber-400 text-[11px] font-semibold uppercase tracking-[0.2em] text-black">
      Préprod — environnement de test
    </div>
  );
};

export default PreprodBanner;
